import { c as _c } from "react/compiler-runtime";
import { disabledVariants } from "../../styles/utils/disabled";
import { classNames } from "../../utils/classNames";
import { FlexColumn } from "../FlexColumn";
import { ItemAvatar, ItemContent, ItemDescription, ItemSide, ItemTitle } from "../Item";
import { List, ListItem } from "../List";
import { TimelineSkeleton } from "./TimelineSkeleton";
function Timeline(t0) {
  const $ = _c(10);
  let children;
  let className;
  let props;
  if ($[0] !== t0) {
    ({
      className,
      children,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = className;
    $[3] = props;
  } else {
    children = $[1];
    className = $[2];
    props = $[3];
  }
  let t1;
  if ($[4] !== className) {
    t1 = classNames("w-full", className);
    $[4] = className;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  let t2;
  if ($[6] !== children || $[7] !== props || $[8] !== t1) {
    t2 = <List className={t1} showBorder={false} variant="framed" {...props}>{children}</List>;
    $[6] = children;
    $[7] = props;
    $[8] = t1;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  return t2;
}
export function TimelineItem(t0) {
  const $ = _c(11);
  let active;
  let children;
  let props;
  if ($[0] !== t0) {
    ({
      active,
      children,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = active;
    $[2] = children;
    $[3] = props;
  } else {
    active = $[1];
    children = $[2];
    props = $[3];
  }
  let t1;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = classNames("after:my-1.5 after:ml-3 after:block after:h-4 after:w-0.5 after:rounded-full after:bg-text-primary", "last:after:hidden");
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const t2 = !active;
  let t3;
  if ($[5] !== t2) {
    t3 = classNames("gap-4", disabledVariants({
      disabled: t2
    }));
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== children || $[8] !== props || $[9] !== t3) {
    t4 = <FlexColumn className={t1}><ListItem className={t3} variant="unstyled" {...props}>{children}</ListItem></FlexColumn>;
    $[7] = children;
    $[8] = props;
    $[9] = t3;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  return t4;
}
export function TimelineAvatar(t0) {
  const $ = _c(9);
  let className;
  let props;
  if ($[0] !== t0) {
    ({
      className,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = props;
  } else {
    className = $[1];
    props = $[2];
  }
  const t1 = props.icon && "p-0.5";
  let t2;
  if ($[3] !== className || $[4] !== t1) {
    t2 = classNames("rounded bg-bg-additional-1", t1, className);
    $[3] = className;
    $[4] = t1;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== props || $[7] !== t2) {
    t3 = <ItemAvatar className={t2} size={24} {...props} />;
    $[6] = props;
    $[7] = t2;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  return t3;
}
export const TimelineContent = ItemContent;
export const TimelineDescription = ItemDescription;
export const TimelineSide = ItemSide;
export function TimelineTitle(t0) {
  const $ = _c(4);
  let props;
  if ($[0] !== t0) {
    ({
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
  } else {
    props = $[1];
  }
  let t1;
  if ($[2] !== props) {
    t1 = <ItemTitle size="sm" {...props} />;
    $[2] = props;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return t1;
}
export { Timeline, TimelineSkeleton };